import { createFileRoute } from "@tanstack/react-router";

import MessengerFullscreen from "../../../components/MessengerFullscreen";
import MessengerFullscreenSkeleton from "../../../components/MessengerFullscreenSkeleton";

export const Route = createFileRoute("/_panel/_messenger/messenger/")({
  pendingComponent: MessengerFullscreenSkeleton,
  component: Component,
});

function Component() {
  return (
    <div className="-m-4 h-[calc(100dvh-4rem)] overflow-hidden sm:-m-6 sm:mb-[-8rem] sm:h-dvh">
      <MessengerFullscreen />
    </div>
  );
}
